import React from 'react';
import { useAuthentication } from './use-authentication';
import { useAutoLogout } from './use-autologout';

export type KeycloakAutoLogoutProps = {
    idleTimeInMinutes: number;
    redirectUri: string;
    debounce?: number;
    children?: React.ReactNode;
};

export const KeycloakAutoLogout: React.FC<KeycloakAutoLogoutProps> = ({
    redirectUri,
    idleTimeInMinutes,
    debounce,
    children,
}) => {
    const auth = useAuthentication();
    const logout = () => auth.logout({ redirectUri });
    useAutoLogout(auth, idleTimeInMinutes, redirectUri, debounce, logout);

    return <>{children}</>;
};
